import { useMeetingState } from '@daily-co/daily-react'

export function useProviderConnected() {
  const providerConnected = useMeetingState() === 'joined-meeting'
  return { providerConnected }
}
